import React from "react";
import styles from "./orderModal.module.scss";

const OrderModal = ({ handleToggle, value, handleUpdate, status }) => {
  const handleNo = () => {
    handleToggle(false);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <p className={styles.message}>
            {value === "packager"
              ? "Are You Sure You Want To Update This Order To Pack?"
              : ` ${
                  status === 1
                    ? "Are You Sure You Want To Update This Order From Pack to Ship"
                    : "Are You Sure You Want To Update This Order From Shipped to Delivered"
                }`}
          </p>
          <div className={styles.buttonGroup}>
            <button className={styles.noButton} onClick={handleNo}>
              No
            </button>
            <button className={styles.yesButton} onClick={handleUpdate}>
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderModal;
